import { createContext, useContext } from 'react';
import { noop } from '../../utils/index.js';
export const ToastStateContext = createContext({
    state: { toasts: [] }
});
export function useToastState() {
    return useContext(ToastStateContext);
}
export const ToastDispatchContext = createContext({
    dispatch: noop
});
export function useToastDispatch() {
    return useContext(ToastDispatchContext);
}
//# sourceMappingURL=ToastContext.js.map